<template>
  <div style="display: flex; flex-direction: column; align-items: center">
    <div
      style="
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 800px;
        margin-bottom: 20px;
      "
    >
      <img
        :src="'/static/images/goods/' + targetGood.image"
        style="width: 60px; margin-right: 15px"
      />
      <h3
        v-if="targetGood != null"
        style="
          font-size: 22px;
          text-align: left;

          font-weight: bold;
          color: #13395e;
          display: flex;
          flex: 1;
        "
      >
        {{ targetGood.text }} {{ $t("bavul_desc") }}
      </h3>
    </div>
    <div id="goz_esnetme">
      <paused
        v-if="pause"
        @click="
          $root.$emit('pause', !pause);
          pause = false;
        "
      ></paused>

      <img
        src="/static/images/animation_300_kzfi61nv.gif"
        style="width: 200px; position: absolute; left: -60px; bottom: 0px"
      />

      <div
        v-if="levelUp"
        style="
          position: absolute;
          left: 0px;
          top: 0px;
          width: 100%;
          height: 100%;
          background-color: #253b53;
          align-items: center;
          justify-content: center;
          display: flex;
          z-index: 8123512;
          flex-direction: column;
        "
      >
        <img
          src="/static/images/animation_300_kzfi61nv.gif"
          style="width: 200px"
        />
        <h1 style="font-weight: bold; color: white; font-size: 36px">
          Seviye {{ level }}
        </h1>
      </div>
      <div style="perspective: 2500px; display: flex; flex-direction: row">
        <div
          style="
            position: relative;
            width: 300px;
            height: 511px;
            animation-duration: 0.5s;
            animation: 0.5s;
            z-index: 9;
          "
          :style="{ transformOrigin: level < 4 ? 'right' : 'right 63px' }"
          :class="
            kapali
              ? level < 4
                ? 'kapali'
                : 'kapali-4'
              : level < 4
              ? 'acik'
              : 'acik-4'
          "
        >
          <img
            style="position: absolute; left: 0; top: 0; width: 100%"
            src="/static/images/bavul1.png"
            alt=""
          />
          <div
            style="
              width: 223px;
              height: 338px;
              position: absolute;
              left: 43px;
              top: 89px;
              border-radius: 18px;
              overflow: hidden;
              display: grid;
              grid-column-gap: 5px;
              grid-row-gap: 5px;
            "
            :style="{
              backgroundColor: removeBackground
                ? 'transparent'
                : 'rgb(27 48 70)',
              gridTemplateColumns: 'repeat(' + col + ', 1fr)',
              gridTemplateRows: 'repeat(' + row + ', 1fr)',
            }"
          >
            <div
              v-for="i in row * col"
              @mouseover="rePosition(i)"
              style="
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
              "
              @click="open"
              :style="{
                backgroundColor: removeBackground
                  ? 'transparent'
                  : 'rgb(37, 59, 83)',
              }"
            >
              <div
                v-if="currentPos == i"
                style="
                  width: 100%;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
                :style="{
                  backgroundColor:
                    isTrue === true ? 'green' : isTrue === false ? 'red' : '',
                }"
              >
                <img
                  :src="'/static/images/goods/' + targetGood.image"
                  style="width: 90%"
                />
              </div>

              <div
                v-if="leftStack.some((x) => x.index == i - 1)"
                style="
                  width: 80%;
                  height: 80%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <img
                  :src="
                    '/static/images/goods/' +
                    leftStack.find((x) => x.index == i - 1).image
                  "
                  style="width: 100%"
                />
              </div>
            </div>
          </div>
        </div>

        <div
          style="position: relative; width: 300px; height: 511px; z-index: 7"
        >
          <img
            style="position: absolute; left: 0; top: 0; width: 100%"
            src="/static/images/bavul2.png"
            alt=""
          />
          <div
            style="
              width: 223px;
              height: 338px;
              position: absolute;
              left: 34px;
              top: 89px;
              border-radius: 18px;
              overflow: hidden;
              display: grid;
              grid-column-gap: 5px;
              grid-row-gap: 5px;
            "
            :style="{
              backgroundColor: 1 == 2 ? 'transparent' : 'rgb(27 48 70)',
              gridTemplateColumns: 'repeat(' + col + ', 1fr)',
              gridTemplateRows: 'repeat(' + row + ', 1fr)',
            }"
          >
            <div
              v-for="i in row * col"
              style="
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
              "
              :style="{
                backgroundColor: 1 == 2 ? 'transparent' : 'rgb(37, 59, 83)',
              }"
            >
              <div
                v-if="rightStack.some((x) => x.index == i - 1)"
                style="
                  width: 80%;
                  height: 80%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <img
                  :src="
                    '/static/images/goods/' +
                    rightStack.find((x) => x.index == i - 1).image
                  "
                  style="width: 100%"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
import moment from "moment";
import axios from "axios";
export default {
  name: "Bavul",
  props: ["config"],
  data() {
    return {
      pause: false,
      stack: [],
      kapali: false,
      goods: [
        {
          image: "book.png",
          text: "Kitabı",
        },
        {
          image: "dental-care.png",
          text: "Diş fırçası və diş pastasını",
        },
        {
          image: "eyeglasses.png",
          text: "Gözlüğü",
        },
        {
          image: "headphone.png",
          text: "Kulaklığı",
        },
        {
          image: "jacket.png",
          text: "Gömleği",
        },
        {
          image: "leather-jacket.png",
          text: "Ceketi",
        },
        {
          image: "running-shoes.png",
          text: "Ayakkabıları",
        },
        {
          image: "smartphone.png",
          text: "Telefonu",
        },
        {
          image: "winter-hat.png",
          text: "Bereyi",
        },
      ],
      leftStack: [],
      rightStack: [],
      currentPos: null,
      removeBackground: false,
      isTrue: null,
      row: 2,
      col: 2,
      level: 1,
      maxLevel: 4,
      trueStack: 0,
      targetGood: null,
      levelUp: false,
      lastDate: new Date().getTime(),
      interval: null,
      point: 0,
      hafizaTimeout: null,
      reactions: [],
      falseStack: 0,
    };
  },
  created() {
    this.start();
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearTimeout(this.hafizaTimeout);
    this.interval = null;
  },
  methods: {
    start() {
      this.kapali = false;
      this.removeBackground = false;
      this.currentPos = null;
      this.leftStack = [];
      this.rightStack = [];
      this.isTrue = null;
      this.targetGood = this.goods[_.random(0, this.goods.length - 1)];
      this.lastDate = new Date().getTime();

      this.interval = setInterval(() => {
        axios.post("module/savePoints", {
          points: [
            {
              point:
                this.reactions.reduce((counter, item) => (item += counter), 0) /
                this.reactions.length,
              type: "tepki",
            },
          ],
          module_id: this.$store.state.modules.find((k) => k.slug == "bavul")
            .module_id,
        });
      }, 60000);

      this.hafizaTimeout = setTimeout(() => {
        this.reactionInterval = setTimeout(() => {
          axios.post("module/savePoints", {
            points: [
              {
                point: this.point,
                type: "hafiza",
              },
            ],
            module_id: this.$store.state.modules.find((k) => k.slug == "bavul")
              .module_id,
          });
        }, 60000);
      }, 60000);

      for (
        let index = 0;
        index < Math.floor((this.col * this.row) / 2);
        index++
      ) {
        while (true) {
          var ii = _.random(0, this.row * this.col - 1) - 1;
          if (this.leftStack.some((k) => k.index == ii) === false) {
            break;
          }
        }

        var row = Math.floor(ii / this.col);
        var stack = [];

        for (
          let index = row * this.col;
          index < row * this.col + this.col;
          index++
        ) {
          stack.push(index);
        }

        var reverseStack = stack.slice().reverse();

        while (true) {
          var good = this.goods[_.random(0, this.goods.length - 1)];
          if (good.image != this.targetGood.image) {
            break;
          }
        }

        this.leftStack.push({
          index: ii,
          ...good,
          rightIndex: reverseStack[stack.findIndex((k) => k == ii)],
        });
      }

      for (
        let index = 0;
        index < Math.floor((this.col * this.row) / 2) - 1;
        index++
      ) {
        while (true) {
          var ii = _.random(0, this.row * this.col - 1);
          if (
            this.leftStack.some((k) => k.rightIndex == ii) === false &&
            this.rightStack.some((k) => k.index == ii) === false
          ) {
            break;
          }
        }

        this.rightStack.push({
          index: ii,
          ...this.goods[_.random(0, this.goods.length - 1)],
        });
      }
    },
    rePosition(index) {
      if (this.kapali) return;
      if (this.leftStack.some((k) => k.index == index - 1) == false) {
        this.currentPos = index;
      }
    },
    open() {
      if (this.currentPos != null) {
        this.kapali = true;
        setTimeout(() => {
          this.removeBackground = true;
        }, 200);

        var row = Math.floor((this.currentPos - 1) / this.col);
        var stack = [];

        for (
          let index = row * this.col;
          index < row * this.col + this.col;
          index++
        ) {
          stack.push(index);
        }

        var reverseStack = stack.slice().reverse();

        var pos =
          stack[reverseStack.findIndex((k) => k == this.currentPos - 1)];

        setTimeout(() => {
          if (this.rightStack.some((k) => k.index == pos)) {
            this.isTrue = false;
            this.falseStack += 1;
          } else {
            this.isTrue = true;
            this.trueStack += 1;
            this.reactions.push(new Date().getTime() - this.lastDate);
            this.point += this.level;
          }

          setTimeout(() => {
            this.lastDate = new Date().getTime();
            this.start();
            
          }, 1200);
        }, 800);
      }
    },
  },
  watch: {
    trueStack: function (newValue, oldValue) {
      if (this.trueStack == 0 || this.level == 4) return;
      setTimeout(() => {
        if (this.trueStack % 2 == 0) {
          this.level = Math.min(this.level + 1, this.maxLevel);
          this.trueStack = 0;
          this.falseStack = 0;
          this.levelUp = true;
          setTimeout(() => {
            this.levelUp = false;
          }, 2500);
        }
      }, 1000);
    },
    falseStack: function (newValue, oldValue) {
      if (this.falseStack == 0 || this.level == 1) return;
      setTimeout(() => {
        if (this.falseStack % 2 == 0) {
          this.level = Math.max(this.level - 1, 1);
          this.falseStack = 0;

          this.levelUp = true;
          setTimeout(() => {
            this.levelUp = false;
          }, 2500);
        }
      }, 1000);
    },
    level: function () {
      this.col = Math.min(1 + this.level, 4);
      this.row = Math.min(1 + this.level, 4);
    },
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 800px;
  max-width: 800px;
  height: 600px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: column;
  background-size: 100%;
  transform: rotateY(0deg);
  overflow: hidden;
  background-image: url(/static/images/2411.jpg);
  background-position: bottom;
  background-size: cover;

  .kapali {
    transition-duration: 0.8s;
    transition-property: transform;
    transform: rotateY(180deg);
  }

  .acik {
    transform: rotateY(0deg);
    transition-duration: 0.8s;
    transition-property: transform;
  }

  .kapali-4 {
    transition-duration: 0.8s;
    transition-property: transform;
    transform: rotateY(180deg) rotate(0deg);
  }

  .acik-4 {
    transform: rotateY(0deg) rotate(18deg);
    transition-duration: 0.8s;
    transition-property: transform;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/modules/Bavul.vue